import React from "react";
import { FormConatiner, SubmitButton, MyButton } from "./SalesPageCss";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Switch,
  TextField,
} from "@mui/material";
import NumberFormat from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import {
  AddSalesAgent,
  GetSalesCompanies,
} from "../../Redux/Actions/addInstallerAction";
import ReCAPTCHA from "react-google-recaptcha";
import { Formik, useFormik } from "formik";
import * as yup from "yup";
import Loading from "../../components/loading/Loading";
import LoadingSoultion from "../../components/loading/loadingSolution";
import { useLocation, useParams } from "react-router-dom";
const SalesPage = () => {
  const disptach = useDispatch();
  const location = useLocation();
  let email = location?.search?.includes("=")
    ? location?.search?.split("=")[1]
    : "";
  const recaptchaRef = React.useRef(null);
  const { isLoading } = useSelector((state) => state.proposal);
  const token = recaptchaRef.current?.getValue();
  const [data, setData] = React.useState({
    w9pdf: "",
    company_logo: "",
    company_exist: true,
  });
  const { salesError } = useSelector((state) => state?.installerReducer);
  console.log("salesError", salesError?.response?.data?.errors);
  const [disable, setDisable] = React.useState(true);
  console.log("data", data);
  React.useEffect(() => {
    disptach(GetSalesCompanies());
  }, []);
  const { salesCompanies } = useSelector((state) => state.installerReducer);
  console.log("salesCompanies", salesCompanies);
  let video = "https://www.boxbyld.tech/intro.mp4";
  const onVerify = () => {
    setDisable(false);
  };
  console.log("email", email);
  const validationSchema = yup.object().shape({
    email: yup
      .string("Enter your email")
      .email("Enter a valid email")
      .required("Email is required"),
    referrer: yup.string("Enter your email").email("Enter a valid email"),
    password: yup
      .string("Enter your password")
      .min(8, "Password should be of minimum 8 characters length")
      .required("Password is required"),
    password_confirmation: yup
      .string("Enter your password confirm")
      .min(8, "Password should be of minimum 8 characters length")
      .required("Password Confirmation is required"),
    name: yup
      .string("Enter your  Name")
      .min(3, "Name Should be more than 3 letters")
      .max(25, "Name Should be less than 21 letters")
      .required("Name is required"),
    business_type: yup
      .mixed()
      .oneOf(["individual", "company"])
      .required("Business type is required"),
    company_id: yup.string().when("company_exist", {
      is: (company_exist) => company_exist === false,
      then: yup.string("company_id").required("company_id  is required"),
    }),
    company_email: yup
      .string("Enter Your company_email")
      .when("company_exist", {
        is: (company_exist) => company_exist === true,
        then: yup
          .string("company_email")
          .email("inValid Email")
          .required("company_email Name is required")
          .min(2, "company_email atleast has 2 letters")
          .max(127, "company_email max letters is 127 letters"),
      }),
    company_address: yup
      .string("Enter Your company_address")
      .when("company_exist", {
        is: (company_exist) => company_exist === true,
        then: yup
          .string("company_address")
          .required("company_address Name is required")
          .min(2, "company_address atleast has 5 letters")
          .max(127, "company_address max letters is 150 letters"),
      }),
    business: yup.string("Enter Your Business Name").when("company_exist", {
      is: (company_exist) => company_exist === true,
      then: yup
        .string("Enter Your Business name")
        .required("Business Name is required")
        .min(2, "Business atleast has 2 letters")
        .max(127, "Business max letters is 127 letters"),
    }),

    bank_name: yup.string("Enter Your bank name").when("company_exist", {
      is: (company_exist) => company_exist === true,
      then: yup
        .string("Bank name")
        .required("Bank name is required")
        .min(2, "Bank name  atleast has 2 letters")
        .max(127, "Bank name  max letters is 127 letters"),
    }),
    routing: yup.string("Enter Your routing  Name").when("company_exist", {
      is: (company_exist) => company_exist === true,
      then: yup
        .string("Routing ")
        .required("Routing  is required")
        .min(2, "Routing  atleast has 2 letters")
        .max(127, "Routing  max letters is 127 letters"),
    }),
  });
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      name: "",
      business_type: "",
      business: "",
      password_confirmation: "",
      referrer: location?.search?.includes("=") ? email : "",
      company_email: "",
      bank_name: "",
      routing: "",
      company_exist: "",
      company_id: "",
      company_address: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("email", values.email);
      formData.append("business_type", values.business_type);
      formData.append("name", values.name);
      formData.append("password", values.password);
      formData.append("password_confirmation", values.password_confirmation);
      formData.append("business", values.business);
      formData.append("company_email", values.company_email);
      formData.append("bank_name", values.bank_name);
      formData.append("bank_routing_no", values.routing);
      formData.append("w9pdf", data.w9pdf);
      formData.append("company_logo", data.company_logo);
      formData.append("phone", data.phone);
      formData.append("referrer", values.referrer);
      formData.append("google_recaptcha", data.google_recaptcha);
      formData.append("company_id", values.company_id);
      formData.append("company_exist", data.company_exist);
      formData.append("company_address", values.company_address);
      if (formik.values.business_type === "company") {
        if (data.company_exist === false) {
          if (data?.company_logo) {
            disptach(AddSalesAgent(formData));
          }
        } else {
          disptach(AddSalesAgent(formData));
        }
      }
      if (formik.values.business_type === "individual") {
        if (data?.w9pdf) {
          disptach(AddSalesAgent(formData));
        }
      }
    },
  });
  console.log("whasdsadsa", formik.errors);
  React.useEffect(() => {
    formik.initialValues.referrer = location?.search?.includes("=")
      ? email
      : "";
    formik.values.phone = data.phone;
  }, [email]);
  let textError;
  console.log("datadatadatadata", formik.values);
  if (formik.values.business_type === "company") {
    if (!data?.company_logo) {
      textError = "You must upload company logo";
    }

    if (data.company_logo?.size > 5000000) {
      textError = "The file is too large";
    }
  }
  if (formik.values.business_type === "individual") {
    if (!data.w9pdf) {
      textError = "You must upload pdf file";
    }
    if (data.w9pdf?.type !== "application/pdf") {
      textError = "The file format must be PDF";
    }

    if (data.w9pdf?.size > 5000000) {
      textError = "The file is too large";
    }
  }

  React.useEffect(() => {
    if (formik.values.business_type === "individual") {
      formik.values.business = "";
    }
    if (formik.values.business_type === "company") {
      data.w9pdf = "";
      setData({ ...data, w9pdf: "" });
    }
  }, [formik.values.business_type]);
  let allErrors = salesError?.response?.data?.errors;

  // for (const property in allErrors) {
  //   return <p>{`${property}: ${allErrors[property]}`}</p>;
  // }

  return (
    <>
      <FormConatiner>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            columns={18}
            spacing={3}
            direction="row"
            justifyContent="flex-start"
            alignItems="stretch"
          >
            <Grid item xs={18} mb={3}>
              <h2 style={{ textAlign: "center" }}>Form For Sales</h2>
            </Grid>
            <Grid item xs={18} mb={3}>
              <h3> Personal Data</h3>
              <br></br>
              <hr />
            </Grid>
            {/* <Grid container item columns={18}> */}
            <Grid
              container
              item
              lg={12}
              md={12}
              xs={12}
              spacing={2}
              direction="row"
              justifyContent="flex-start"
              alignItems="baseline"
            >
              {" "}
              {/* Name of Sales */}
              <Grid item md={9} sm={9} xs={18} mb={3}>
                <TextField
                  fullWidth
                  id="name"
                  name="name"
                  label="Name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                />
              </Grid>
              {/* email of Sales */}
              <Grid item md={9} sm={9} xs={18} mb={3}>
                <TextField
                  fullWidth
                  id="email"
                  name="email"
                  label="Email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
              </Grid>
              {/*Refer email */}
              <Grid item md={9} sm={9} xs={18} mb={3}>
                <TextField
                  fullWidth
                  id="email"
                  name="referrer"
                  label="Referreral Email"
                  value={formik.values.referrer}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.referrer && Boolean(formik.errors.referrer)
                  }
                  helperText={formik.touched.referrer && formik.errors.referrer}
                />
              </Grid>
              {/* business Phone */}
              <Grid item md={9} sm={9} xs={18} mb={3}>
                <NumberFormat
                  format="+1 (###) ###-####"
                  fullWidth
                  // allowEmptyFormatting
                  customInput={TextField}
                  mask="_"
                  label="Phone"
                  name="phone"
                  required
                  onValueChange={(values) => {
                    setData({ ...data, phone: values.value });
                  }}
                  // value={formik.values.phone}
                  // error={formik.touched.phone && Boolean(formik.errors.phone)}
                  // helperText={formik.touched.phone && formik.errors.phone}
                />
              </Grid>
              {/* Password of installer */}
              <Grid item md={9} sm={9} xs={18} mb={3}>
                <TextField
                  fullWidth
                  id="password"
                  name="password"
                  label="Password"
                  type="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.password && Boolean(formik.errors.password)
                  }
                  helperText={formik.touched.password && formik.errors.password}
                />
              </Grid>
              {/* Confirm Password of installer */}
              <Grid item md={9} sm={9} xs={18} mb={3}>
                <TextField
                  fullWidth
                  id="password_confirmation"
                  name="password_confirmation"
                  label="password_confirmation"
                  type="password"
                  value={formik.values.password_confirmation}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.password_confirmation &&
                    Boolean(formik.errors.password_confirmation)
                  }
                  helperText={
                    formik.touched.password_confirmation &&
                    formik.errors.password_confirmation
                  }
                />
              </Grid>
            </Grid>
            <Grid item lg={6} md={6} xs={18}>
              {/* <source src={movie} type="video/mp4"/> */}
              <video
                width="100%"
                height="248"
                controls
                loop
                autoPlay
                muted
                style={{ border: "1px solid black", borderRadius: ".3rem" }}
              >
                <source src={video} />
              </video>
              {/* <embed  autoPlay muted src={video} style={{border:"1px solid black",borderRadius:".3rem",height:"248px",width:"100%"}}></embed> */}
              {/* <iframe title="vimeo-player" src="https://player.vimeo.com/video/750058795?autoplay=1" width="100%" height="248" frameborder="0"  allowfullscreen></iframe> */}
            </Grid>
            {/* </Grid> */}
            {/*  Business  Info  */}
            <Grid item xs={18} mb={3}>
              <h3> Business Info </h3>
              <br></br>
              <hr />
            </Grid>
            {/* business  Type*/}
            <Grid item md={18} sm={18} xs={18}>
              <FormControl>
                <FormLabel id="business_type">Business Type</FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="business_type"
                  name="business_type"
                  onChange={formik.handleChange}
                  value={formik.values.business_type}
                >
                  <FormControlLabel
                    value="individual"
                    control={<Radio />}
                    label="individual"
                  />
                  <FormControlLabel
                    value="company"
                    control={<Radio />}
                    label="company"
                  />
                </RadioGroup>
                <FormHelperText
                  error={
                    formik.touched.business_type &&
                    Boolean(formik.errors.business_type)
                  }
                >
                  {formik.touched.business_type && formik.errors.business_type}
                </FormHelperText>
              </FormControl>
            </Grid>

            {/* business_type company */}
            {formik.values.business_type === "company" ? (
              <>
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Companies
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Companies"
                      onChange={formik.handleChange}
                      name="company_id"
                      error={
                        formik.touched.company_id &&
                        Boolean(formik.errors.company_id)
                      }
                      helperText={
                        formik.touched.company_id && formik.errors.company_id
                      }
                      required={data?.company_exist ? true : false}
                    >
                      {salesCompanies?.map((company) => {
                        return (
                          <MenuItem value={company?.id} key={company?.id}>
                            {company?.title}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item md={6} sx={9} xs={18} mb={3}>
                  <p> Can you find your company?</p>
                  <span>Yes</span>

                  {/* <InputLabel id="demo-simple-select-label">
                  </InputLabel> */}

                  <Switch
                    name="company_exist"
                    onChange={(e) => {
                      setData({ ...data, company_exist: !e.target.checked });
                    }}
                  />
                  <span>No I can't</span>
                </Grid>
                {data?.company_exist === false ? (
                  <>
                    {" "}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        id="business"
                        name="business"
                        label="Business Name"
                        value={formik.values.business}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.business &&
                          Boolean(formik.errors.business)
                        }
                        helperText={
                          formik.touched.business && formik.errors.business
                        }
                        required
                      />
                    </Grid>
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        id="company_email"
                        type="email"
                        name="company_email"
                        label="Company email"
                        value={formik.values.company_email}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.company_email &&
                          Boolean(formik.errors.company_email)
                        }
                        helperText={
                          formik.touched.company_email &&
                          formik.errors.company_email
                        }
                        required
                      />
                    </Grid>
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        id="company_address"
                        name="company_address"
                        label="Company address"
                        value={formik.values.company_address}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.company_address &&
                          Boolean(formik.errors.company_address)
                        }
                        helperText={
                          formik.touched.company_address &&
                          formik.errors.company_address
                        }
                        required
                      />
                    </Grid>
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        id="business"
                        name="bank_name"
                        label="Bank name "
                        value={formik.values.bank_name}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.bank_name &&
                          Boolean(formik.errors.bank_name)
                        }
                        helperText={
                          formik.touched.bank_name && formik.errors.bank_name
                        }
                        required
                      />
                    </Grid>
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        id="business"
                        name="routing"
                        label="Bank routing number"
                        value={formik.values.routing}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.routing &&
                          Boolean(formik.errors.routing)
                        }
                        helperText={
                          formik.touched.routing && formik.errors.routing
                        }
                        required
                      />
                    </Grid>
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <MyButton variant="contained" component="label">
                        Upload company logo
                        <input
                          type="file"
                          hidden
                          name="company_logo"
                          onChange={(e) =>
                            setData({
                              ...data,
                              company_logo: e.target.files[0],
                            })
                          }
                        />
                        <span
                          style={{
                            color: "",
                            fontSize: "12px",
                            margin: "0 1rem",
                          }}
                        >
                          {data?.company_logo?.name ? (
                            <> ({data?.company_logo?.name} )</>
                          ) : (
                            <></>
                          )}
                        </span>
                      </MyButton>
                      {data.company_logo !== undefined && (
                        <>
                          <span style={{ color: "red", fontSize: "0.8rem" }}>
                            {textError}
                          </span>
                        </>
                      )}
                    </Grid>
                  </>
                ) : (
                  <></>
                )}
              </>
            ) : null}

            {/* Logo */}
            {formik.values.business_type === "individual" ? (
              <>
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <MyButton variant="contained" component="label">
                    Upload w9
                    <input
                      type="file"
                      hidden
                      name="w9pdf"
                      onChange={(e) =>
                        setData({ ...data, w9pdf: e.target.files[0] })
                      }
                    />
                  </MyButton>
                  {data.w9pdf !== undefined && (
                    <>
                      <span style={{ color: "red", fontSize: "0.8rem" }}>
                        {textError}
                      </span>
                    </>
                  )}
                </Grid>
              </>
            ) : null}
          </Grid>
          <ReCAPTCHA
            ref={recaptchaRef}
            // size="invisible"
            sitekey="6LdDRIcgAAAAAPlYCZb2TpxVrkbQtoeNLPrCLJzA"
            // onChange={onChangeCaptcha}
            onChange={async (e) => {
              await onVerify();
              await setDisable(false);
              setData({ ...data, google_recaptcha: e });
            }}
            style={{ padding: "18px 0" }}
            onExpired={() => {
              setDisable(true);
            }}
            onErrored={() => {
              setDisable(true);
            }}
          />
          {allErrors ? (
            Object.keys(allErrors).map((oneKey, i) => {
              return (
                <li style={{ color: "red" }} key={i}>
                  {allErrors[oneKey]}
                </li>
              );
            })
          ) : (
            <></>
          )}

          <Grid item xs={18} mb={3}>
            <SubmitButton type="submit">Submit</SubmitButton>
          </Grid>
        </form>
      </FormConatiner>
      {isLoading && <LoadingSoultion />}
    </>
  );
};

export default SalesPage;
